/* Tomassi — motion runtime: scroll reveal + stagger, parallax, hover magnetico.
   Tutto no-op se l'utente preferisce ridurre il movimento. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Scroll reveal con stagger automatico tra fratelli marcati [data-reveal-group] */
  function initReveal() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var groups = {};
    items.forEach(function (el) {
      var g = el.getAttribute('data-reveal-group');
      if (g != null) {
        groups[g] = (groups[g] || 0);
        el.style.setProperty('--reveal-delay', (groups[g] * 80) + 'ms');
        groups[g]++;
      }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* 2. Parallax verticale leggero su [data-parallax] (intensità data-parallax="0.15") */
  function initParallax() {
    if (reduce) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        var r = el.getBoundingClientRect();
        var mid = r.top + r.height / 2;
        var off = (mid - vh / 2) * -speed;
        el.style.setProperty('--py', off.toFixed(1) + 'px');
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* 3. Hover magnetico su [data-magnetic] (solo puntatore fine) */
  function initMagnetic() {
    if (reduce || !window.matchMedia('(pointer: fine)').matches) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-magnetic]'));
    els.forEach(function (el) {
      var strength = parseFloat(el.getAttribute('data-magnetic')) || 0.3;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var mx = (ev.clientX - (r.left + r.width / 2)) * strength;
        var my = (ev.clientY - (r.top + r.height / 2)) * strength;
        el.style.setProperty('--mx', mx.toFixed(1) + 'px');
        el.style.setProperty('--my', my.toFixed(1) + 'px');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--mx', '0px');
        el.style.setProperty('--my', '0px');
      });
    });
  }

  function init() { initReveal(); initParallax(); initMagnetic(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
